module.exports = __webpack_public_path__ + "img/workflows.77f1b7bf.svg";